import * as React from 'react';

import {useInView} from "react-intersection-observer";


export const AnimatedText = ({textTranslate}) => {
  const [ref, inView  ] = useInView({triggerOnce:true} );
  return (

      <div ref={ref} className={"project-description__info " +  (inView? "wow animate__animated animate__backInLeft " :" hide")}>
        {textTranslate('year' )     ?  <p>{textTranslate('year' )}         </p>  :""}
        {textTranslate('location' ) ?  <p>{textTranslate('location' )}     </p>  :""}
        {textTranslate('client' )   ?  <p>{textTranslate('client' )}        </p>  :" "}
      </div>

  );
};
